import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import useSearchMgrInstance from 'coreHooks/useSearchMgrInstance';

import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';
import InTheMoodForToggle from 'brandComponents/InTheMoodFor/InTheMoodForToggle';
import OpenFiltersButton from 'brandComponents/OpenFiltersButton';
import Typography from 'brandComponents/Typography';
import {QUERY_MIN_LENGTH} from 'brandConstants';

import messages from './messages';

import styles from './ProductListFiltersControl.module.scss';

const ProductListFiltersControl = () => {
	const intl = useIntl();
	const {searchType, searchInstanceKey} = useCategoryContext(true) || {};
	const searchMgr = useSearchMgrInstance({
		searchType,
		key: searchInstanceKey
	});
	const searchModel = searchMgr.getStoredSearchModel();
	const originalQuery = searchModel?.getSearchQuery();
	const totalProducts = originalQuery?.length ? searchModel?.getTotalProductsNumber() : 0;
	const selectedRefinements = searchModel?.getSelectedRefinements();

	const isCategoryPage = !!selectedRefinements?.cgid;
	const hasProducts = searchModel?.getTotalProductsNumber() > 0;
	const showFilters = hasProducts || isCategoryPage;

	// we have to remove the wildcard
	const query = useMemo(() => originalQuery && originalQuery.replaceAll('*', ''), [originalQuery]);

	if (!showFilters) {
		return null;
	}

	return (
		<div className={cn(
			styles['filters-button__wrapper'],
			'filters-button__wrapper',
			{
				[styles['search']]: query,
				'search': query
			}
		)}>
			{(query?.length >= QUERY_MIN_LENGTH && totalProducts > 0) && (
				<div className={cn(styles['filters-button__search-query'], 'filters-button__search-query')}>
					<Typography variant="h1">
						{`${intl.formatMessage(messages.results)} "${query}"`}
						<span className={styles['filters-button__search-query__total']}>
							{totalProducts}
						</span>
					</Typography>
				</div>
			)}
			<div className={styles['filters-button__buttons']}>
				<InTheMoodForToggle />
				<OpenFiltersButton />
			</div>
		</div>
	);
};

export default ProductListFiltersControl;
